import React from 'react';

interface ShowIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  color?: string;
  className?: string;
}

const ShowIcon: React.FC<ShowIconProps> = ({ width = 20, height = 20, fill = '#161616', color, className }) => {
  const fillColor = color || fill;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 5C8.15 5 6.45 5.65 5.1 6.75L3.5 5.15C5.15 3.75 7.45 3 10 3C12.55 3 14.85 3.75 16.5 5.15L14.9 6.75C13.55 5.65 11.85 5 10 5ZM10 15C11.85 15 13.55 14.35 14.9 13.25L16.5 14.85C14.85 16.25 12.55 17 10 17C7.45 17 5.15 16.25 3.5 14.85L5.1 13.25C6.45 14.35 8.15 15 10 15ZM10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default ShowIcon;


